export default {"src":"/_next/static/media/INFlag.364dfea0.svg","height":24,"width":32};